import { render, staticRenderFns } from "./YunTiUinLoginTip.vue?vue&type=template&id=1a631341"
import script from "./YunTiUinLoginTip.vue?vue&type=script&lang=js"
export * from "./YunTiUinLoginTip.vue?vue&type=script&lang=js"
import style0 from "./YunTiUinLoginTip.vue?vue&type=style&index=0&id=1a631341&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports